// extracted by mini-css-extract-plugin
module.exports = {"menu":"MenuModal_menu__7mzfs","toolBar":"MenuModal_toolBar__9pStf","closeModal":"MenuModal_closeModal__Q9FfF"};